// Explicit registration manifest for the site subapp's Stimulus controllers.
import { application } from 'site/controllers/application';
import CalloutController from 'components/controllers/callout_controller';
import ContactSalesController from 'components/controllers/contact_sales_controller';
import DnsoundController from 'components/controllers/dnsound_controller';

application.register('callout', CalloutController);
application.register('contact-sales', ContactSalesController);
application.register('dnsound', DnsoundController);
